import React from 'react';
import { useSelector } from 'react-redux';

import Loader from '@components/loader/Loader';
import { RootState } from '@core/redux/store';

export const GlobalLoader = () => {
  const loading = useSelector((state: RootState) => state.apiState.loading);
  const isLoading = Object.values(loading).some((val) => val);

  return isLoading ? <Loader position="fullCenter" /> : null;
};
